import { USER_PERMISSIONS } from "config/constants";
import List from "./List";
import Detail from "./Detail";
import PackageForm from "./PackageForm";

const router = [
  {
    key: "project-type-list",
    path: "/setting/project-type",
    component: List,
    exact: true,
    permissions: [USER_PERMISSIONS.PROJECT_CONFIG],
  },
  {
    key: "project-type-detail",
    path: "/setting/project-type/:id",
    component: Detail,
    exact: true,
    permissions: [USER_PERMISSIONS.PROJECT_CONFIG],
  },
  {
    key: "project-type-package-create",
    path: "/setting/project-type/:id/package/create",
    component: PackageForm,
    exact: true,
    permissions: [USER_PERMISSIONS.PROJECT_CONFIG],
  },
  {
    key: "project-type-package-edit",
    path: "/setting/project-type/:id/package/:pid/edit",
    component: PackageForm,
    exact: true,
    permissions: [USER_PERMISSIONS.PROJECT_CONFIG],
  },
];
export default router;
